import './people-card.scss';
import './people-detail.scss';
import './people-list.scss';
